import { PropertySource } from "./source";
export interface PropertyList {
  properties: string[];
  source: PropertySource;
}
export async function get_properties(id: number) : Promise<PropertyList> {
  const url: URL = new URL('https://event-application.null-988.workers.dev');
  url.pathname = '/api/v1/lombardo/links';
  url.searchParams.set('id',String(id));

  const resp = await fetch(url,{
    "method": "GET"
  }).then(async (response) => {
    return await response.json();
  });

  return {
    properties: resp.properties,
    source: resp.source,
  };
}
